var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "box" },
    [
      _c("sc-form", {
        ref: "form",
        attrs: {
          form: _vm.form,
          rules: _vm.rules,
          hasStyle: false,
          buttonsStyle: false,
          "is-edit": ""
        },
        on: { submit: _vm.onReleaseForPayment },
        scopedSlots: _vm._u([
          {
            key: "fields",
            fn: function(ref) {
              var fields = ref.fields
              return [
                _c(
                  "sc-table",
                  {
                    staticClass: "sc-pre-invoice-audit-table",
                    attrs: {
                      data: _vm.invoices,
                      "per-page": _vm.pagination.limit,
                      "checked-rows": _vm.checkedInvoices,
                      "row-class": function() {
                        return "sc-pre-invoice-audit-table__table__row"
                      },
                      "default-sort": "order_number",
                      "default-sort-direction": "asc",
                      "checkbox-position": "right",
                      paginated: "",
                      checkable: "",
                      scrollable: ""
                    },
                    on: {
                      "update:checkedRows": function($event) {
                        _vm.checkedInvoices = $event
                      }
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(ref) {
                          var row = ref.row
                          return [
                            _c(
                              "sc-table-column",
                              {
                                attrs: {
                                  label: "N° do Pedido",
                                  field: "order_number",
                                  sortable: ""
                                }
                              },
                              [
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "sc-recon-pre-invoice-table__table__link",
                                    attrs: {
                                      target: "_blank",
                                      href:
                                        "/ng#/order-number/" + row.order_number
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(row.order_number) +
                                        "\n            "
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "sc-table-column",
                              {
                                attrs: {
                                  label: "Cod. Rastreamento",
                                  field: "tracking_code",
                                  sortable: ""
                                }
                              },
                              [
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      href:
                                        "http://status-testing.intelipost.com.br/tracking/" +
                                        row.tracking_code,
                                      target: "_blank"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(row.tracking_code) +
                                        "\n            "
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "sc-table-column",
                              {
                                attrs: {
                                  label: "Docto Transp",
                                  field: "cte_number",
                                  sortable: ""
                                }
                              },
                              [
                                _c(
                                  "router-link",
                                  {
                                    staticClass:
                                      "sc-pre-invoice-audit-table__table__link",
                                    attrs: {
                                      target: "_blank",
                                      to:
                                        "/recon/invoice-detail/" +
                                        row.id +
                                        "?action=cte"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          [row.cte.number, row.cte.serie].join(
                                            "-"
                                          )
                                        ) +
                                        "\n            "
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "sc-table-column",
                              {
                                attrs: {
                                  label: "NF",
                                  field: "invoice",
                                  sortable: ""
                                }
                              },
                              [
                                _c(
                                  "router-link",
                                  {
                                    staticClass:
                                      "sc-pre-invoice-audit-table__table__link",
                                    attrs: {
                                      target: "_blank",
                                      to:
                                        "/recon/invoice-detail/" +
                                        row.id +
                                        "?action=values"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          [
                                            row.invoice.number,
                                            row.invoice.serie
                                          ].join("-")
                                        ) +
                                        "\n            "
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "sc-table-column",
                              {
                                attrs: {
                                  label: "Docto Cobrança",
                                  field: "doccob",
                                  sortable: ""
                                }
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      [
                                        row.doccob.number,
                                        row.doccob.serie
                                      ].join("-")
                                    ) +
                                    "\n          "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "sc-table-column",
                              {
                                attrs: {
                                  label: "Status",
                                  field: "status",
                                  sortable: ""
                                }
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(row.status.label) +
                                    "\n          "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "sc-table-column",
                              {
                                attrs: {
                                  label: "Valor da NF",
                                  field: "invoice_value",
                                  sortable: ""
                                }
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm._f("currency")(row.invoice.value)
                                    ) +
                                    "\n          "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "sc-table-column",
                              {
                                attrs: {
                                  label: "Frete TMS",
                                  field: "tms_value",
                                  sortable: ""
                                }
                              },
                              [
                                _c(
                                  "router-link",
                                  {
                                    staticClass:
                                      "sc-pre-invoice-audit-table__table__link",
                                    attrs: {
                                      target: "_blank",
                                      to:
                                        "/recon/invoice-detail/" +
                                        row.id +
                                        "?action=values"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm._f("currency")(row.tms_value)
                                        ) +
                                        "\n            "
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "sc-table-column",
                              {
                                attrs: {
                                  label: "Frete Docto",
                                  field: "cte_value",
                                  sortable: ""
                                }
                              },
                              [
                                _c(
                                  "router-link",
                                  {
                                    staticClass:
                                      "sc-pre-invoice-audit-table__table__link",
                                    attrs: {
                                      target: "_blank",
                                      to:
                                        "/recon/invoice-detail/" +
                                        row.id +
                                        "?action=values"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm._f("currency")(row.cte_value)
                                        ) +
                                        "\n            "
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "sc-table-column",
                              {
                                key: "table_form." + row.id + ".payment_type",
                                attrs: {
                                  label: "Valor à Pagar",
                                  field: "payment_type"
                                }
                              },
                              [
                                _c(
                                  "sc-field",
                                  [
                                    _vm.canSelectPaymentType(row)
                                      ? _c(
                                          "sc-select",
                                          {
                                            attrs: { expanded: "" },
                                            model: {
                                              value: _vm.getInvoiceById(
                                                fields,
                                                row.id
                                              ).payment_type,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.getInvoiceById(
                                                    fields,
                                                    row.id
                                                  ),
                                                  "payment_type",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "getInvoiceById(fields, row.id).payment_type"
                                            }
                                          },
                                          [
                                            _c(
                                              "option",
                                              { attrs: { value: "tms_value" } },
                                              [_vm._v("TMS")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "option",
                                              { attrs: { value: "cte_value" } },
                                              [_vm._v("CTE")]
                                            )
                                          ]
                                        )
                                      : _c("p", [_vm._v("-")])
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]
                        }
                      }
                    ])
                  },
                  [
                    _c(
                      "template",
                      { attrs: { slot: "footer" }, slot: "footer" },
                      [
                        _vm.totalCount
                          ? _c("p", [
                              _c("strong", [_vm._v("Total de registros:")]),
                              _vm._v(" "),
                              _c("span", [_vm._v(_vm._s(_vm.totalCount))])
                            ])
                          : _vm._e()
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "template",
                      { attrs: { slot: "bottom-left" }, slot: "bottom-left" },
                      [
                        _c("sc-table-per-page", {
                          model: {
                            value: _vm.pagination.limit,
                            callback: function($$v) {
                              _vm.$set(_vm.pagination, "limit", $$v)
                            },
                            expression: "pagination.limit"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "sc-form__footer columns sc-pre-invoice-audit-table__footer"
                  },
                  [
                    _c("div", { staticClass: "column" }, [
                      _c(
                        "div",
                        { staticClass: "buttons is-right" },
                        [
                          _c("sc-button", {
                            attrs: { theme: "danger", text: "Estornar" },
                            on: { click: _vm.onReverseClick }
                          }),
                          _vm._v(" "),
                          _c("sc-button", {
                            attrs: {
                              type: "submit",
                              theme: "primary",
                              text: "Liberar pagamento"
                            }
                          })
                        ],
                        1
                      )
                    ])
                  ]
                )
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9b874a7a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9b874a7a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-recon/features/pre-invoice-audit/components/sc-pre-invoice-audit-table/ScPreInvoiceAuditTable.vue
// module id = null
// module chunks = 